module.exports = __webpack_public_path__ + "static/media/default_profile_image.6dc8909f.png";